import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { OrderTagState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/order-tag";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const OrderTagDetails = memo(function OrderTagDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<OrderTagState>) {
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      inputValue={inputValue}
      label="Order tags"
      placeholder="Type and press Enter to add tags"
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
